import AbstractCanvas from './AbstractCanvas'
import { CANVAS_WIDTH, CANVAS_HEIGHT } from '../utils/settings'
import colorBlend from '../utils/color-blend'
import { hexToRgb, rgbToHsv } from '../utils/colors'
import { getImage } from '../utils/image-loader'

const BikeImageComponentCanvas = ({
  highlighted,
  zIndex,
  componentId,
  imgUrl,
  secondaryImgUrl,
  hex
}) => {
  const className = highlighted
    ? 'velorbis-customizer-bike-canvas-highlighted'
    : ''

  const paintData = { imgUrl, secondaryImgUrl, hex }

  const shouldRepaint = (a, b) => {
    return a.imgUrl !== b.imgUrl || a.hex !== b.hex
  }

  const paint = (ctx, { imgUrl, secondaryImgUrl, hex }) => {
    // Draw possibly colorized image
    let imgData = getImage(imgUrl).getImageData()
    if (hex) {
      imgData = colorize(ctx, imgData, hex)
    }
    ctx.putImageData(imgData, 0, 0)

    // Draw secondary image (non-colorized)
    if (secondaryImgUrl) {
      let img = getImage(secondaryImgUrl).getImageObj()
      ctx.drawImage(img, 0, 0, CANVAS_WIDTH, CANVAS_HEIGHT)
    }
  }

  return (
    <AbstractCanvas
      className={className}
      zIndex={zIndex}
      name={componentId}
      paintData={paintData}
      shouldRepaint={shouldRepaint}
      paint={paint}
    />
  )
}
function colorize(ctx, src, hex) {
  let dst = ctx.createImageData(CANVAS_WIDTH, CANVAS_HEIGHT)
  let dstData = dst.data
  let srcData = src.data
  let [r, g, b] = hexToRgb(hex)
  let brightness = rgbToHsv(r, g, b)[2]
  for (let p = 0, len = srcData.length; p < len; p += 4) {
    //Skip transparent pixels
    if (srcData[p + 3] === 0) {
      continue
    }

    //TODO: Should we use hardlight or a different blend mode?
    dstData[p] = colorBlend(srcData[p], r, brightness)
    dstData[p + 1] = colorBlend(srcData[p + 1], g, brightness)
    dstData[p + 2] = colorBlend(srcData[p + 2], b, brightness)
    dstData[p + 3] = srcData[p + 3]
  }
  return dst
}

export default BikeImageComponentCanvas
